import {
  applySituationImproveDateFromDuration,
  buildCustomerSituationDateRules,
  buildCustomerSituationDurationRules,
  clearCustomerSituationFixFields,
  requiresCustomerSituationFix,
} from "@/helper/customerSituationFixHelper";

/**
 * Shared logic for "متى يظبط العميل حاله" + "تاريخ ظبط العميل لحاله".
 *
 * Override in component when needed:
 * - activeSituationFixClassId  → class_id_agent (consultant) or class_id_cs (CS)
 * - situationFixRoleAllowed    → false to hide for certain roles
 */
export const customerSituationFixMixin = {
  computed: {
    activeSituationFixClassId() {
      return this.agent?.class_id_agent;
    },
    situationFixRoleAllowed() {
      return true;
    },
    showCustomerSituationFixFields() {
      if (!this.situationFixRoleAllowed) {
        return false;
      }
      return requiresCustomerSituationFix(
        this.agent,
        this.activeSituationFixClassId,
        (id) => this.isRejectedClass(id)
      );
    },
    requiresCustomerSituationFixFields() {
      return this.showCustomerSituationFixFields;
    },
    customerSituationDurationRules() {
      return buildCustomerSituationDurationRules(this.requiresCustomerSituationFixFields);
    },
    customerSituationDateRules() {
      return buildCustomerSituationDateRules(this.requiresCustomerSituationFixFields);
    },
  },
  watch: {
    showCustomerSituationFixFields(visible) {
      if (!visible && this.agent) {
        clearCustomerSituationFixFields(this.agent);
      }
    },
    "agent.mortgage_duration_id"(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateMortgageEndDate();
      }
    },
  },
  methods: {
    calculateMortgageEndDate() {
      applySituationImproveDateFromDuration(
        this.agent,
        this.$store.state.mortgageDurations
      );
    },
  },
};
